
import React, { Component } from 'react';
import { Input, Button, Row } from 'reactstrap';
import { BottomSheet } from 'react-spring-bottom-sheet'
import { RiDeleteBin5Line } from "react-icons/ri";

const modelUtil = require('../../../../utils/basket/modelUtil.js');
const formatter = require('../../../../utils/formatter/formatter.js');

class SubModifierComponent extends Component 
{
    constructor(props)
    {
        super(props);
    }

    render()
    {
        var components = [];

        this.props.modifierModel.modifierGroupModels.forEach (modifierGroupModel =>
        {
            this.renderModifierGroup(modifierGroupModel, components, 0)
        });

        if (components.length <= 0)
            return null;

        return <div style={{marginLeft:'10px', background:`var(--menu-sub-modifier-background-color)`, padding:'5px'}}>
                    {components}
                    <hr style={{marginBottom:'5px', marginTop:'5px'}}/>
                    <div onClick={()=>{this.props.onEditSelection();}}><b>Edit Selection</b></div>
                </div>
    }

    renderModifierGroup(modifierGroupModel, components, margin)
    {
        modifierGroupModel.modifierModels.forEach (modifierModel =>
        {
            if (modifierModel.quantity <= 0)
                return;

            var subComponents = [];
            modifierModel.modifierGroupModels.forEach (subModifierGroupModel =>
            {
                this.renderModifierGroup(subModifierGroupModel, subComponents, margin+10)
            });

            var priceComponent = null;
            if (modifierModel.modifier.price > 0)
            {
                priceComponent = formatter.convertToCurrencyFormat(modifierModel.quantity * modifierModel.modifier.price);
            }
                
            components.push(<div style={{marginLeft: `${margin}px`}}>
                                <table style={{width:'100%'}}>
                                    <tr>
                                        <td style={{width:'1%', whiteSpace:'nowrap'}}>
                                            <div style={{marginRight:'5px'}}>{modifierModel.quantity}x</div>
                                        </td>
                                        <td style={{width:'99%', textAlign:'left'}}>
                                            {modifierModel.modifier.caption}
                                        </td>
                                        <td style={{width:'1%', whiteSpace:'nowrap'}}>
                                            {priceComponent}
                                        </td>
                                    </tr>
                                </table>    
                                {subComponents}
                            </div>)
        })
    }
}

export default SubModifierComponent;